module.exports = __webpack_public_path__ + "img/qa.4bfe8cc4.svg";